import React, { useEffect, useState } from 'react';
import Icon from '../icons';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    children?: any;
    className?: string;
    title?: string;
    back?: string;
    _ref?: any;
    onClose?: () => void;
    outsideClose?: boolean;
    isAfterOpenRender?: boolean
}

const Drawer: React.FC<Props> & {
    Button: React.FC<Props>
    Content: React.FC<Props>
} = ({ children, className = '', title, back, _ref, onClose , outsideClose = true, isAfterOpenRender = false}) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDrawer = () => {
        console.log('toggleDrawer', _ref);
        //console.log('toggleDrawer', isOpen);
        if (onClose && isOpen) { 
            onClose();
         }
        setIsOpen(!isOpen);
    };

    const Button = children?.find?.((child: any) => child.type.displayName === 'Drawer.Button') || null;
    const Content = children?.find?.((child: any) => child.type.displayName === 'Drawer.Content') || null;

    useEffect(() => {
        if (_ref) {
            _ref.current = {
                open: () => {
                    setIsOpen(true)
                },
                close: () => {
                    setIsOpen(false)
                }
            }
        }
    }, [_ref]);


    

    return (
        <div className="drawer drawer-end w-auto" >
            <input type="checkbox" className="drawer-toggle" checked={isOpen} onChange={toggleDrawer} />
            <div className={`drawer-content ${Button.props.className || ''}`} onClick={toggleDrawer}>
                {Button}
            </div>
            <div className="drawer-side fixed z-50">
                <label className="drawer-overlay" onClick={()=>{if(outsideClose){toggleDrawer()}}}></label>
                <div className={`menu p-4 w-80 flex flex-col bg-white text-base-content h-screen ${Content.props.className || ''}`}>
                    <div className='flex items-center justify-between border-b border-[#8D6E63] h-[2.813rem] mb-2 flex-shrink-0 pb-4 pr-4'>
                        <p className='text-[1.063rem] text-[#755B51] font-semibold'>{Content.props.title || ''}</p>
                        <button onClick={toggleDrawer} className='bg-primary text-white p-1 rounded-md'>
                            <Icon name='close' size={1.25} />
                        </button>
                    </div>
                    <div className='flex-1 overflow-auto relative'>                        
                        {isAfterOpenRender? (
                            <>
                                {isOpen? Content: ``}
                            </>
                        ): Content}                        
                    </div>
                    
                </div>
            </div>
        </div>
    );
};

Drawer.Button = ({ children, className }) => {
    return (<>{children}</>);
}

Drawer.Content = ({ children, className }) => {
    return (<>{children}</>);
}

Drawer.Button.displayName = 'Drawer.Button';
Drawer.Content.displayName = 'Drawer.Content';

export default Drawer;